<template>
	<div class="color-container">
		<button v-if="hideDeselect" type="button" class="color-button" v-on:click="deselect">
			<i class="fa fa-times"></i>
		</button>
		<button v-for="color in colors"
			type="button"
			class="color-button"
			:class="{active: color == value}" 
			:style="{backgroundColor:color}" 
			v-on:click="selectColor(color)">

			<i v-if="color == value" class="fa fa-check"></i>

		</button>
	</div>
</template>
<script type="text/javascript">

export default {
	name: "PallettePicker",
	props:["colors","value","hideDeselect"],
	methods: {
		selectColor(color) {
			this.$emit("input",color)
		},
		deselect() {
			this.$emit("input",null)
		}
	}
}
</script>

<style type="text/css" scoped>
	.color-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.color-button {
		width: 40px;
		height: 40px;
		border-radius: 10px;
		text-align: center;
		margin: 2px;
		border: 1px solid #d3d3d3;
		cursor: pointer;
	}

	.color-button i {
		background-color: rgba(255,255,255,0.2);
		border-radius: 50%;
		display: block;
		padding: 5px;
	}

	.color-button:hover {
		border: 1px solid #404040;
	}
</style>